// extracted by mini-css-extract-plugin
module.exports = {"container":"_2EiX1k0VrMVifvFLLzKOc8","groupsList":"_3ARaQJTdwqwBDEDNcCXmbJ"};